module.exports = __webpack_public_path__ + "assets/img/banner10.9ac43f31.jpg";